import React from 'react';
import { LiaArrowCircleUpSolid } from "react-icons/lia";
import processBottomImg from "../../assets/images/processBottom.png";
import FadeIn from '../common/FadeIn';

const ProcessBottomBanner = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className="h-[94.7vh] md:h-[92vh] p-[70px_25px] bg-cover bg-center bg-no-repeat text-white text-center flex flex-col items-center justify-between"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${processBottomImg})`,
      }}
    >
      <FadeIn>
        <p className='leading-[1] tracking-[0em] text-[22px] md:text-[30px] font-normal'>
          <span className='font-PromenadeItalic'>By</span> <span className='font-saolDisplayItalic'> Princy Patel | SeaSalt Creative </span>
        </p>
      </FadeIn>

      <div className="my-auto flex flex-col items-center justify-center">
        <FadeIn>
          <h2 className='font-saolDisplayMedium text-[14px] md:text-base leading-[1.2] tracking-[0.1em] font-normal uppercase text-center mb-[35px]'>
            Website Development
          </h2>
        </FadeIn>
        <FadeIn>
          <h1 className='font-saolDisplayItalic text-[28px] md:text-[66px] tracking-[0em] text-center uppercase leading-[1.1] font-normal max-w-[716px] mx-auto'>
            Websites made to feel like you.
          </h1>
        </FadeIn>
      </div>

      <FadeIn>
        <div className='flex gap-3 items-center font-PromenadeItalic leading-[1] tracking-[0em] text-[22px] md:text-[30px] text-center font-normal'>
          Scroll
          <LiaArrowCircleUpSolid
            onClick={scrollToTop}
            className='cursor-pointer hover:opacity-80 transition-opacity'
          />
          Back
        </div>
      </FadeIn>
    </div>
  );
};

export default ProcessBottomBanner;
